export default "__VITE_ASSET__BotdpaZ4__"